import type { FisherPortraitId } from './outfitter';

// Explicit inputs only. The art registry governs the completed exports and their consumers.
export const FISHER_PORTRAIT_URLS: Readonly<Record<FisherPortraitId, string>> = {
  'fisher-salt': new URL('./portraits/fisher-salt.png', import.meta.url).href,
  'fisher-reef': new URL('./portraits/fisher-reef.png', import.meta.url).href,
  'fisher-ember': new URL('./portraits/fisher-ember.png', import.meta.url).href,
  'fisher-moss': new URL('./portraits/fisher-moss.png', import.meta.url).href,
};
export const OUTFITTER_KEEPER_URL = new URL('./portraits/outfitter-keeper.png', import.meta.url).href;
export const OUTFITTER_PREVIEW_URLS: Readonly<Record<string, string>> = {
  'lantern-amber': new URL('./outfitter/lantern-amber-preview.png', import.meta.url).href,
  'lantern-green': new URL('./outfitter/lantern-green-preview.png', import.meta.url).href,
  'pennant-striped': new URL('./outfitter/pennant-striped-preview.png', import.meta.url).href,
};
